import { ScreenType, useScreenType } from "@redotech/react-util/screen";
import { Flex } from "@redotech/redo-web/flex";
import { memo, type ReactNode } from "react";
import * as css from "./modalless-page-layout.module.css";

export interface ModallessPageLayoutProps {
  uiSelector: string;
  children: ReactNode;
  footer?: ReactNode;
  footerUiSelector?: string;
  topBar?: ReactNode;
}

export const ModallessPageLayout = memo(function ModallessPageLayout({
  uiSelector,
  children,
  footer,
  footerUiSelector,
  topBar,
}: ModallessPageLayoutProps) {
  const screen = useScreenType();
  const isDesktop = screen === ScreenType.DESKTOP;

  return (
    <Flex
      className={css.root}
      data-modalless-page=""
      data-ui={uiSelector}
      flexDirection="column"
      overflow="hidden"
      w="full"
    >
      {topBar}

      <Flex
        align="center"
        flexDirection="column"
        grow={1}
        minH="none"
        overflowY="auto"
        px={isDesktop ? "xl" : "none"}
        shrink={1}
        w="full"
      >
        <Flex
          flexDirection="column"
          gap="3xl"
          maxW="2xl"
          px={isDesktop ? "5xl" : "xl"}
          py={isDesktop ? "8xl" : "3xl"}
          w="full"
        >
          {children}
        </Flex>
      </Flex>

      {footer ? (
        <Flex
          borderColor="primary"
          borderStyle="solid"
          borderTopWidth="1px"
          data-ui={footerUiSelector ?? `${uiSelector}-footer`}
          dir="column"
          pb={isDesktop ? "6xl" : "xl"}
          px={isDesktop ? "6xl" : "xl"}
          shrink={0}
          w="full"
        >
          {footer}
        </Flex>
      ) : null}
    </Flex>
  );
});
